var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"banner w-100",attrs:{"src":require("@/assets/img/banner.png"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }